module.exports = "query GetAccount {\n  account {\n    ...AccountFragment\n  }\n}\n"